/* 4Women — Selector de packs en la ficha.
 *
 * Vivia inline dentro de snippets/fw-packs.liquid. Se movio aqui porque el
 * quick-add de coleccion trae la ficha por fetch + DOMParser y la inyecta con
 * morph: un <script> que llega por innerHTML no se ejecuta. Ahi dentro el
 * selector quedaba inerte y la clienta que elegia 3 unidades se llevaba 1, sin
 * ningun error visible.
 *
 * Todo lo de aqui delega sobre document (change, click, submit en captura),
 * asi que una sola carga cubre las fichas inyectadas igual que las servidas.
 */
(() => {
  if (window.__fwPacks) return;
  window.__fwPacks = true;

  /* La eleccion se guarda por producto: el tema rehace parte de la ficha
     al cambiar de talla o color y si no, el selector volvia a 1 unidad. */
  const memoria = new Map();

  /* Composicion del pack: una entrada por prenda, {h: handle, id: variante,
     tocado: si la clienta la cambio a mano}. Las que no toco siguen a la
     seleccion de arriba; las que toco se quedan quietas. */
  const armado = new WeakMap();

  const catalogo = (raiz) => {
    if (raiz.__cat) return raiz.__cat;
    try {
      raiz.__cat = JSON.parse(raiz.querySelector('[data-fw-catalogo]').textContent);
    } catch (e) {
      raiz.__cat = { colores: [] };
    }
    return raiz.__cat;
  };

  /* La variante vigente se lee del campo del formulario y no de un atributo
     propio: ese campo es el que el tema mantiene al dia al cambiar de talla,
     y es el mismo que viajaria al carrito por el camino nativo. */
  const varianteActual = (raiz) => {
    const form = raiz.closest('form');
    const campo = form && form.querySelector('[name="id"]');
    return campo ? String(campo.value) : '';
  };

  const color = (raiz, handle) => {
    const cat = catalogo(raiz);
    return cat.colores.find((c) => c.h === handle) || cat.colores[0];
  };

  const colorDeVariante = (raiz, id) =>
    catalogo(raiz).colores.find((c) => c.tallas.some((t) => String(t.id) === String(id)));

  const primeraDisponible = (c) => {
    const t = c.tallas.find((x) => x.d) || c.tallas[0];
    return t ? String(t.id) : '';
  };

  const porDefecto = (raiz) => {
    const id = varianteActual(raiz);
    const c = colorDeVariante(raiz, id) || color(raiz, raiz.dataset.handle);
    return { h: c ? c.h : raiz.dataset.handle, id: id || (c ? primeraDisponible(c) : ''), tocado: false };
  };

  const pintar = (raiz, cantidad) => {
    const caja = raiz.querySelector('[data-fw-armar]');
    const lista = raiz.querySelector('[data-fw-us]');
    const cat = catalogo(raiz);
    if (!caja || !lista || !cat.colores.length) return;

    if (cantidad < 2) {
      caja.hidden = true;
      lista.textContent = '';
      armado.delete(raiz);
      return;
    }

    const base = porDefecto(raiz);
    const previo = armado.get(raiz) || [];
    const est = [];
    for (let i = 0; i < cantidad; i++) {
      const p = previo[i];
      est.push(p && p.tocado ? p : { h: base.h, id: base.id, tocado: false });
    }
    armado.set(raiz, est);

    const toggle = raiz.querySelector('[data-fw-toggle]');
    lista.hidden = !(toggle && toggle.getAttribute('aria-expanded') === 'true');

    lista.textContent = '';
    est.forEach((u, i) => {
      const c = color(raiz, u.h);
      if (!c) return;
      const talla = c.tallas.find((t) => String(t.id) === String(u.id));

      const li = document.createElement('li');
      li.className = 'fw-packs__u';
      li.dataset.i = String(i);

      const cab = document.createElement('span');
      cab.className = 'fw-packs__u-n';
      cab.innerHTML =
        'Prenda <span class="fw-num">' +
        (i + 1) +
        '</span> \u00b7 <b>' +
        c.n +
        '</b>' +
        (talla ? ' \u00b7 <b>' + talla.t + '</b>' : '');
      li.appendChild(cab);

      const cols = document.createElement('div');
      cols.className = 'fw-packs__cols';
      cols.setAttribute('role', 'radiogroup');
      cols.setAttribute('aria-label', 'Color de la prenda ' + (i + 1));
      cat.colores.forEach((cc) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fw-packs__c';
        b.dataset.h = cc.h;
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', cc.h === u.h ? 'true' : 'false');
        b.setAttribute('aria-label', cc.n);
        b.title = cc.n;
        if (cc.img) {
          const im = document.createElement('img');
          im.src = cc.img;
          im.alt = '';
          /* eager y no lazy: estas fotos se crean en el momento en que la
             clienta elige un tramo, o sea que nacen ya dentro de la
             pantalla. Con lazy el navegador tiene que decidir si estan
             visibles antes de pedirlas, y mientras tanto se ven cuadros
             vacios justo cuando acaba de tocar. Son 34px de ancho. */
          im.loading = 'eager';
          im.width = 40;
          im.height = 52;
          b.appendChild(im);
        } else {
          b.style.background = cc.sw || '#ccc';
        }
        cols.appendChild(b);
      });
      li.appendChild(cols);

      const tals = document.createElement('div');
      tals.className = 'fw-packs__tals';
      tals.setAttribute('role', 'radiogroup');
      tals.setAttribute('aria-label', 'Talla de la prenda ' + (i + 1));
      c.tallas.forEach((t) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fw-packs__t';
        b.dataset.id = String(t.id);
        b.textContent = t.t;
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', String(t.id) === String(u.id) ? 'true' : 'false');
        if (!t.d) {
          b.disabled = true;
          b.setAttribute('aria-label', t.t + ' agotada');
        }
        tals.appendChild(b);
      });
      li.appendChild(tals);

      lista.appendChild(li);
    });

    /* El resumen dice en una linea lo que hay dentro. Cuando todas las
       prendas coinciden se lee "3 x Negro S"; cuando la clienta mezclo, se
       enumeran para que pueda revisar sin abrir. */
    const resumen = raiz.querySelector('[data-fw-resumen]');
    if (resumen) {
      const partes = est.map((u) => {
        const c = color(raiz, u.h);
        const t = c && c.tallas.find((x) => String(x.id) === String(u.id));
        return c ? c.n + (t ? ' ' + t.t : '') : '';
      });
      const todasIguales = partes.every((x) => x === partes[0]);
      /* innerHTML y no textContent porque el contador va en .fw-num: es
         una cifra, y en esta marca las cifras tienen su propia fuente. */
      resumen.innerHTML = todasIguales
        ? '<span class="fw-num">' + est.length + '\u00d7</span> ' + partes[0]
        : partes.join(' + ');
    }

    caja.hidden = false;
  };

  const aplicar = (raiz, cantidad, abrir) => {
    /* Al elegir un tramo el constructor se abre solo: la clienta acaba de
       decir cuantas prendas quiere, y lo siguiente que necesita ver es
       cuales son. Plegado obligaba a un clic extra que nadie pedia.

       Solo se abre cuando el cambio viene de un clic en un tramo. En el
       repintado por cambio de talla se respeta como estaba. */
    if (abrir) {
      const t = raiz.querySelector('[data-fw-toggle]');
      if (t) t.setAttribute('aria-expanded', Number(cantidad) >= 2 ? 'true' : 'false');
    }

    const campo = raiz.querySelector('[data-fw-qty]');
    if (campo) campo.value = cantidad;

    raiz.querySelectorAll('.fw-packs__op').forEach((op) => {
      const radio = op.querySelector('input');
      const activo = Number(radio.value) === Number(cantidad);
      radio.checked = activo;
      op.classList.toggle('is-on', activo);
    });

    memoria.set(raiz.dataset.producto, String(cantidad));

    pintar(raiz, Number(cantidad));
  };

  document.addEventListener('change', (evento) => {
    const radio = evento.target instanceof Element && evento.target.closest('.fw-packs__op input');
    if (!radio) return;
    aplicar(radio.closest('fw-packs'), radio.value, true);
  });

  document.addEventListener('click', (evento) => {
    const t = evento.target instanceof Element ? evento.target : null;
    if (!t) return;

    const toggle = t.closest('[data-fw-toggle]');
    if (toggle) {
      const raiz = toggle.closest('fw-packs');
      const lista = raiz.querySelector('[data-fw-us]');
      const abierto = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      lista.hidden = abierto;
      return;
    }

    const chip = t.closest('.fw-packs__c, .fw-packs__t');
    if (!chip) return;

    const raiz = chip.closest('fw-packs');
    const fila = chip.closest('.fw-packs__u');
    if (!raiz || !fila) return;
    const est = armado.get(raiz);
    if (!est) return;

    const i = Number(fila.dataset.i);
    const u = est[i];
    if (!u) return;

    if (chip.classList.contains('fw-packs__c')) {
      const nuevo = color(raiz, chip.dataset.h);
      if (!nuevo) return;
      /* Al cambiar de color se conserva la talla si ese color la tiene
         disponible. Reiniciarla obligaria a volver a elegir lo que ya
         estaba elegido, que es la friccion que hace abandonar el pack. */
      const anterior = color(raiz, u.h);
      const previa = anterior && anterior.tallas.find((x) => String(x.id) === String(u.id));
      const igual = previa && nuevo.tallas.find((x) => x.t === previa.t && x.d);
      u.h = nuevo.h;
      u.id = igual ? String(igual.id) : primeraDisponible(nuevo);
    } else {
      if (chip.disabled) return;
      u.id = String(chip.dataset.id);
    }

    u.tocado = true;
    armado.set(raiz, est);
    pintar(raiz, est.length);
  });

  document.addEventListener('variant:update', () => {
    requestAnimationFrame(() => {
      document.querySelectorAll('fw-packs').forEach((raiz) => {
        const guardada = memoria.get(raiz.dataset.producto);
        if (guardada) aplicar(raiz, guardada);
      });
    });
  });

  /* Agregar al carrito con el pack armado.

     Se escucha en CAPTURA sobre document: la fase de captura de un ancestro
     corre siempre antes que los oyentes del propio formulario, asi que no
     depende del orden en que el tema registre el suyo.

     Si las prendas terminan siendo todas la misma variante que ya esta
     seleccionada arriba, NO se intercepta: ese es el camino nativo del tema,
     que ya esta probado contra carritos reales. Solo se toma el control
     cuando hay mas de una variante distinta, que es lo unico que el
     formulario nativo no sabe mandar. */
  document.addEventListener(
    'submit',
    (evento) => {
      const form = evento.target;
      if (!(form instanceof HTMLFormElement)) return;

      const raiz = form.querySelector('fw-packs');
      if (!raiz) return;

      const est = armado.get(raiz);
      const campo = raiz.querySelector('[data-fw-qty]');
      const cantidad = Number((campo && campo.value) || 1);
      if (!est || cantidad < 2 || est.length !== cantidad) return;

      const ids = est.map((u) => String(u.id));
      if (ids.some((id) => !id)) return;
      if (ids.every((id) => id === ids[0]) && ids[0] === varianteActual(raiz)) return;

      evento.preventDefault();
      evento.stopPropagation();
      agregar(raiz, form, ids);
    },
    true
  );

  async function agregar(raiz, form, ids) {
    const items = [];
    ids.forEach((id) => {
      const ya = items.find((it) => it.id === id);
      if (ya) ya.quantity += 1;
      else items.push({ id: id, quantity: 1 });
    });

    const boton = form.querySelector('[ref="addToCartButton"], button[type="submit"]');
    raiz.setAttribute('aria-busy', 'true');
    if (boton) boton.setAttribute('disabled', 'true');

    try {
      const ruta = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      const res = await fetch(ruta, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      });
      const datos = await res.json();
      if (!res.ok || (datos && datos.status)) {
        throw new Error((datos && (datos.description || datos.message)) || 'cart/add');
      }

      /* Mismo nombre de evento que emite el tema al agregar (ThemeEvents.
         cartUpdate). Sin `sections` en el detalle el carrito se vuelve a
         pedir al servidor solo: una peticion mas, pero nada que mantener en
         espejo si el tema cambia su markup. Es tambien lo que abre el cajon. */
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: null,
            sourceId: 'fw-packs',
            data: {
              source: 'product-form-component',
              itemCount: ids.length,
              productId: raiz.dataset.producto,
            },
          },
        })
      );
    } catch (error) {
      /* No se cae al camino nativo a proposito: agregaria N veces la misma
         variante, que no es lo que la clienta armo. Mejor que el boton
         vuelva a estar vivo y pueda reintentar. */
      console.error('[fw-packs] no se pudo agregar el pack', error);
    } finally {
      raiz.removeAttribute('aria-busy');
      if (boton) boton.removeAttribute('disabled');
    }
  }
})();
